import { setTransactionsView } from "@actions";
import RefreshButton from "@buttons/RefreshButton";
import PeriodSelect from "@shared/PeriodSelect";
import React from "react";
import { connect } from "react-redux";
import { Form, Grid } from "semantic-ui-react";
import CollectionWeekFilters from "./CollectionWeekFilters";
import DatePeriodFilters from "./DatePeriodFilters";

const TransactionFilters = (props) => {
  const { useCollectionWeek, searchParams } = props.view;
  const { hasSelection } = props.filters;

  const onChange = (name, value) => {
    props.setTransactionsView({
      searchParams: { ...searchParams, [name]: value },
    });
  };

  const renderControls = () => {
    switch (useCollectionWeek) {
      case 2:
        return (
          <DatePeriodFilters refresh={props.refresh} onChange={onChange} />
        );
      case 3:
        return (
          <CollectionWeekFilters refresh={props.refresh} onChange={onChange} />
        );
      default:
        return (
          <RefreshButton refresh={props.refresh} disabled={!hasSelection} />
        );
    }
  };

  return (
    <Form id="companyFilters">
      <Grid>
        <Grid.Row>
          <Grid.Column width={16}>
            <Form.Field inline>
              <PeriodSelect
                disabled={!hasSelection}
                value={useCollectionWeek}
                onChange={(e, { value }) =>
                  props.setTransactionsView({ useCollectionWeek: value })
                }
              />
            </Form.Field>
            {renderControls()}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Form>
  );
};

const mapStateToProps = (state) => {
  return {
    logIn: state.logIn,
    filters: state.transactionsFilters,
    view: state.transactionsView,
  };
};

export default connect(mapStateToProps, { setTransactionsView })(
  TransactionFilters,
);
